import { configureStore } from '@reduxjs/toolkit';
import { auth } from './reducers/auth.reducer';
import { reg } from './reducers/reg.reducer';
import { categories } from './reducers/categories.reducer';
import { requests } from './reducers/requests.reducer';
import { upload } from './reducers/upload.reducer';
import { events } from './reducers/events.reducer';
import clientVoices from './slices/client-voices-slice';
import program from './slices/program-slice';

export const store = configureStore({
    reducer: {
        auth,
        reg,
        categories,
        requests,
        upload,
        program,
        events,
        clientVoices,
    },
});
